import { useTranslation } from 'react-i18next';

import { Alert } from '@/components/atoms/Alert';
import { Button } from '@/components/atoms/Buttons';

import styles from './SiteActionDialog.module.scss';

/** Whether the site's pens and who holds them are known yet. */
export interface SitePensState {
    loading: boolean;
    /** The overview or the occupied pens failed: no pen can be offered, any could be taken. */
    failed: boolean;
    onRetry: () => void;
}

export function pensKnown(state: SitePensState): boolean {
    return !state.loading && !state.failed;
}

/**
 * The pen list's loading and failure notes, as the New fish group form shows them. Renders
 * nothing once the pens are known.
 */
export default function PensStatus({ state }: { state: SitePensState }) {
    const { t } = useTranslation('fishGroups');
    if (state.failed) {
        return (
            <Alert
                tone="danger"
                size="small"
                action={
                    <Button variant="tertiary" size="small" onClick={state.onRetry}>
                        {t('newFishGroup.retryPens')}
                    </Button>
                }>
                {t('newFishGroup.pensError')}
            </Alert>
        );
    }
    if (state.loading) {
        return <p className={styles.status}>{t('newFishGroup.fields.penLoading')}</p>;
    }
    return null;
}
